import { theme, ThemeConfig } from 'antd';

const ThemeProvider: ThemeConfig = {
  token: {
    fontFamily: "'Inter', sans-serif",
    colorPrimary: '#82489D', // Morado neurAlcrane
    colorBgLayout: '#121212',
    fontSize: 16,
    colorLink: 'rgba(255, 255, 255, 0.44)',
  },
  components: {
    Input: {
      activeBorderColor: '#82489D',
      hoverBorderColor: '#9b59b6',
      activeShadow: '0 0 0 3px rgba(130, 72, 157, 0.25)',
    },
    Button: {
      defaultBg: 'linear-gradient(90deg, hsla(281, 37%, 45%, 1) 0%, hsla(334, 45%, 44%, 1) 63%, hsla(1, 62%, 48%, 1) 100%);',
      defaultColor: '#FFF',
      fontWeight: '600',
      defaultHoverColor: '#E5EBEA',
      contentLineHeightLG: 1,
      paddingBlockLG: 10,
      paddingInlineLG: 20,
    },
    Layout: {
      headerBg: 'rgba(32, 32, 32, 0.7)', //202020
      headerColor: '#E5EBEA',
      siderBg: 'rgba(32, 32, 32, 0.7)',
      bodyBg: '#121212',
    },
    Menu: {
      collapsedWidth: 10,
      itemBg: 'rgba(32, 32, 32, 0.7)',
      itemColor: 'rgba(255, 255, 255, 0.80)',
      itemActiveBg: '#2C2C2C',
      itemSelectedBg: '#2C2C2C',
      itemSelectedColor: '#E5EBEA',
      subMenuItemBg: '#202020',
    },
    Modal: {
      titleFontSize: 24,
      titleLineHeight: 2.5,
    },
    Segmented: {
      itemActiveBg: '#82489D',
      itemHoverBg: '#82489D',
      itemSelectedBg: '#82489D',
      itemColor: 'white',
      itemSelectedColor: 'white',
    },
    Tree: {
      colorBgContainer: '#1D1D1D',
    },
  },
  algorithm: theme.darkAlgorithm,
};

export default ThemeProvider;
